import Vue from 'vue'
import axios from 'axios'

axios.defaults.timeout = 300000 //90000

axios.interceptors.request.use(
  config => {
    let token = localStorage.getItem('token')
    if(token)
    {
      config.headers.common['x-auth-token'] = token;
    }
    config.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    config.headers.common['Accept'] = 'application/json'
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return Promise.resolve(response.data);
  },
  error => {
    // ตรวจสอบว่ามีการยกเลิก request หรือไม่
    if (axios.isCancel(error)) {
      // console.log('Request was canceled:', error.message);
      return Promise.reject(error); // ไม่แจ้งเตือนในกรณีที่ถูกยกเลิก
    }
    
    if (!error.response) {
      Vue.snack.danger('[MKT] Network Error!');
    }
    return Promise.reject(error)
  }
)

export default axios